import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { GrOrderedList } from "react-icons/gr";
import { FileText, Globe, ShoppingCart } from "lucide-react";
import { useTranslation } from "react-i18next";

import Visibility from "./utils/Visibility";
import { FooterCopy } from "./footer";
import { CalcQuantity } from "./utils/CartFunctions";
import { Sheet, SheetTrigger } from "./ui/sheet";
import LangSelect from "./langSelect/langSelect";
import Details from "./Details/Details";
import { indexStore } from "../store/indexStore";

const NavBottom = (props: any) => {
  const { t } = useTranslation();
  const { lang, changeLangBottomSheet } = indexStore();
  const params = useParams();

  const [quantity, setQuantity] = useState(0);

  // تحديث العدد عند تغيير branch_id أو عند إشعار "cart-updated"
  useEffect(() => {
    const branchId = params?.branch_id ? Number(params.branch_id) : null;
    if (!branchId) return;

    const updateQuantity = () => setQuantity(CalcQuantity(branchId));

    // التحديث المبدئي
    updateQuantity();

    // الاستماع لتغيرات السلة
    window.addEventListener("cart-updated", updateQuantity);

    // تنظيف الحدث عند الإزالة
    return () => {
      window.removeEventListener("cart-updated", updateQuantity);
    };
  }, [params.branch_id]);

  // جلب بيانات الطلبات النشطة من localStorage
  const branchId = params.branch_id;
  const tokenOrder = localStorage.getItem(`tokenOrder${branchId}`);
  const activeOrder = Number(localStorage.getItem(`active_order${branchId}`));

  // أنماط
  const classNameNavElement = "flex flex-col gap-2 items-center cursor-pointer";
  const gridClassName = `grid ${
    !activeOrder || !branchId
      ? "grid-cols-2"
      : tokenOrder
      ? "grid-cols-4"
      : "grid-cols-3"
  } items-center text-onBackground`;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-background flex flex-col gap-1 shadow-lg pt-3 z-10">
      <nav className={gridClassName}>
        {/* 🌐 اللغة */}
        <Sheet>
          <SheetTrigger asChild>
            <div
              className={classNameNavElement}
              onClick={() => changeLangBottomSheet(true)}
            >
              <Globe className="text-lg font-semibold" />
              <span className="text-xs font-semibold">
                {lang === "ar" ? "ع" : "EN"}
              </span>
            </div>
          </SheetTrigger>
          <LangSelect />
        </Sheet>

        {/* ℹ️ المعلومات */}
        <Sheet>
          <SheetTrigger asChild>
            <div className={classNameNavElement}>
              <FileText className="text-lg font-semibold" />
              <span className="text-xs font-semibold">{t("gloabl.info")}</span>
            </div>
          </SheetTrigger>
          <Details {...props} />
        </Sheet>

        {/* 🛒 السلة */}
        <Visibility visible={Boolean(branchId && activeOrder)}>
          <Link
            className={classNameNavElement}
            to={`/${params.domain}/${branchId}/cart`}
          >
            <div className="relative">
              <Visibility visible={quantity > 0}>
                <span className="absolute -top-2 -right-2 text-xs bg-primary text-onPrimary p-1 rounded-full">
                  {quantity}
                </span>
              </Visibility>
              <ShoppingCart className="text-lg font-semibold" />
            </div>
            <span className="text-xs font-semibold">{t("gloabl.Cart")}</span>
          </Link>

          {/* 📋 الطلبات */}
          <Visibility visible={!!(tokenOrder && branchId && activeOrder)}>
            <Link
              className={classNameNavElement}
              to={`/${params.domain}/${branchId}/orders`}
            >
              <GrOrderedList className="text-lg font-semibold" />
              <span className="text-xs font-semibold">
                {t("gloabl.orders")}
              </span>
            </Link>
          </Visibility>
        </Visibility>
      </nav>

      <FooterCopy />
    </div>
  );
};

export default NavBottom;
